import { useEffect } from 'react';
import { create } from 'zustand';

/**
 * IS A WAITING CARD (A4 / A5) ON SCREEN? The floating queue bubble hides while
 * one is (A7, David 2026-10-18): on the 1-on-1 page the card says what the
 * bubble would. A count, not a flag, so two cards (or StrictMode's double
 * mount) cannot leave it stuck on or off.
 */
export const useWaitingCardShown = create<{
  count: number;
  show: () => void;
  hide: () => void;
}>((set) => ({
  count: 0,
  show: () => set((s) => ({ count: s.count + 1 })),
  hide: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));

/**
 * Register a mounted card that says what the bubble would. Every such card
 * calls this: the 1-on-1 waiting cards (A4/A5) and the cohort tab's "Your
 * request" card (walkthrough audit B4, which never registered and sat under
 * the bubble).
 */
export function useHidesQueueBubble(): void {
  useEffect(() => {
    const { show, hide } = useWaitingCardShown.getState();
    show();
    return hide;
  }, []);
}
